import React from 'react';
import ShapeName from './ShapeName';

const ShapePopupFour = props => {
    return <ShapeName {...props}>
        {({ shapeName, editButton, customerName }) => {
            return <div className={`shape-popup shape-popup-four`}>
                <div className="shape-popup-body">
                    <div className="shape-popup-title">
                        <div>
                            <div>{shapeName}</div>
                            <div className='customer-name text-muted text-truncate' title={customerName}>{customerName}</div>
                        </div>
                        {editButton}
                    </div>
                </div>
            </div>
        }}
    </ShapeName>;
};

export default ShapePopupFour;